"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canFilterBeAdded = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
function canFilterBeAdded(ctx, addedDisplayFormRef, allFilters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var loadAddedDisplayForm, loadExistingDisplayForms, _a, addedDisplayForm, existingDisplayForms, attributeFilterRef, existingAttributes;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // first filter is always ok, save some useless work upfront
                    if (allFilters.length === 0) {
                        return [2 /*return*/, true];
                    }
                    loadAddedDisplayForm = ctx.backend
                        .workspace(ctx.workspace)
                        .attributes()
                        .getAttributeDisplayForm(addedDisplayFormRef);
                    loadExistingDisplayForms = ctx.backend
                        .workspace(ctx.workspace)
                        .attributes()
                        .getAttributeDisplayForms(allFilters.map(function (item) { return item.attributeFilter.displayForm; }));
                    return [4 /*yield*/, Promise.all([
                            loadAddedDisplayForm,
                            loadExistingDisplayForms,
                        ])];
                case 1:
                    _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), addedDisplayForm = _a[0], existingDisplayForms = _a[1];
                    attributeFilterRef = addedDisplayForm.attribute;
                    existingAttributes = existingDisplayForms.map(function (df) { return df.attribute; });
                    // lookup has to be in existing Attributes array since we support only one DF for one Attribute
                    return [2 /*return*/, !existingAttributes.some(function (existing) { return sdk_model_1.areObjRefsEqual(existing, attributeFilterRef); })];
            }
        });
    });
}
exports.canFilterBeAdded = canFilterBeAdded;
//# sourceMappingURL=uniqueFiltersValidation.js.map